import React from 'react';

import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type FormSectionHeaderProps = {
  title?: string;
  caption?: React.ReactNode;
  optional?: boolean;
  divider?: boolean;
  /** Extra content rendered inline with the title (e.g. tooltip icon) */
  endAdornment?: React.ReactNode;
  /** Extra content rendered inline with the caption */
  captionEndAdornment?: React.ReactNode;
};

const FormSectionHeader = React.memo(function FormSectionHeader({
  title,
  caption,
  optional,
  divider,
  endAdornment,
  captionEndAdornment,
}: FormSectionHeaderProps) {
  return (
    <Stack gap={2}>
      {divider && <Divider />}
      <Stack>
        {title &&
          (endAdornment ? (
            <Stack direction='row' alignItems='center' justifyContent='space-between'>
              <Typography variant='bodyMedium'>{title}</Typography>
              {endAdornment}
            </Stack>
          ) : (
            <Typography variant='bodyMedium'>{title}</Typography>
          ))}
        {optional && (
          <Typography variant='captionRegular' color='text.secondary' sx={{ mt: 0.5 }}>
            Optional
          </Typography>
        )}
        {caption &&
          (captionEndAdornment ? (
            <Stack direction='row' alignItems='center' gap={0.5} sx={{ mt: 0.5 }}>
              <Typography variant='captionRegular' color='text.secondary'>
                {caption}
              </Typography>
              {captionEndAdornment}
            </Stack>
          ) : (
            <Typography variant='captionRegular' color='text.secondary' sx={{ mt: 0.5 }}>
              {caption}
            </Typography>
          ))}
      </Stack>
    </Stack>
  );
});

export default FormSectionHeader;
